<script setup lang="ts">
definePageMeta({
    hidePromotions: true
})

const { site } = useCoreConfig()
const { data: pageData } = await usePageData('blog')

// TODO: Re-enable when blog content migration is ready
// const { data: blogPosts } = await useBlogData()

// SEO
const { getHead, getSeoMeta } = useStrapiSeo(
    pageData.value?.seo || {
        metaTitle: `Blog - ${site.name}`,
        metaDescription: `Her finder du de seneste nyheder fra ${site.name}.`
    }
)

useHead(getHead())
useSeoMeta(getSeoMeta())
// ./ SEO
</script>

<template>
    <NimbusBlogApp
        title="Blog"
        :subtitle="`Her finder du de seneste nyheder fra ${site.name}.`"
        search-field-placeholder="Søg efter et indlæg"
        :error-options="{
            noSearchResultText: 'Din søgning gav desværre ingen resultater.',
            noBlogsText: 'Vi kunne desværre ikke finde nogle indlæg. Venligst opdater siden eller prøv igen senere.'
        }"
    />
</template>
